export const formatMeters = (meters?: number) => {
  if (!meters) return "";

  if (meters < 1000) {
    return `${meters} m`;
  }

  return `${(meters / 1000).toFixed(1).replace(".", ",")} km`;
};
